import script from "./AddOrderTimer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddOrderTimer.vue?vue&type=script&setup=true&lang=ts"

import "./AddOrderTimer.vue?vue&type=style&index=0&id=46d5bd6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46d5bd6e"]])

export default __exports__